module.exports = __webpack_public_path__ + "img/assess-eval.367bbec4.svg";